import {api} from '../../utils/api'

export default {
    /**
     * get all tasks
     * @param commit
     * @param task_id
     * @returns {*|Promise|Promise<any>}
     */
    loadTaskTags({commit}, task_id) {
        return api.call(commit, 'get', '/api/tasktags/'+task_id, null, 'SET_TASKTAGS');
    },


    /**
     * Add new tasktag
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    add({ commit }, {tag, task_id}) {

        // Call register
        return api.call(commit, 'post', `/api/tasktags/${task_id}/${tag}`, false, 'SET_TASKTAGS');
    },

    /**
     * Remove tasktag
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    remove({ commit }, {tag, task_id}) {

        // Call register
        return api.call(commit, 'delete', `/api/tasktags/${task_id}/${tag}`, false, 'DELETE_TASKTAGS');
    },
}
